import { MILLISECONDS_IN_DAY } from "../unit-utils/time";

export function daysBetween(startDate: Date, endDate: Date): number {
    return Math.round(Math.abs((startDate.getTime() - endDate.getTime()) / MILLISECONDS_IN_DAY));
}
